"use client";
export const hotkey = [
  //{ key: (e) => e.shiftKey, display: "⇧" },
  {
    key: "/",
    display: "/",
  },
];
